export function extractWixMediaId(src: string): string {
  if (src) {
    const regex = /static\.wixstatic\.com\/media\/([\w\d~\.\%]*)/;
    const match = src.match(regex);
    return match && match[1];
  }
  return null;
}
